import { blockManifestReader } from "eddev/_internal";
import { dynamic } from "eddev/dynamic";
import core from "../../../blocks/_core";

const manifest = {
  "acf/collections-collections-list": dynamic(() =>
    import("../../../blocks/collections/collections-list.tsx"), "blocks/collections/collections-list.tsx"),
  "acf/content-button": dynamic(() =>
    import("../../../blocks/content/button.tsx"), "blocks/content/button.tsx"),
  "acf/content-category-carousel": dynamic(
    () => import("../../../blocks/content/category-carousel.tsx"),
    "blocks/content/category-carousel.tsx",
  ),
  "acf/content-chip": dynamic(() => import("../../../blocks/content/chip.tsx"), "blocks/content/chip.tsx"),
  "acf/content-ctas": dynamic(() => import("../../../blocks/content/ctas.tsx"), "blocks/content/ctas.tsx"),
  "acf/content-ctas-item": dynamic(
    () => import("../../../blocks/content/ctas-item.tsx"),
    "blocks/content/ctas-item.tsx",
  ),
  "acf/content-donate": dynamic(() => import("../../../blocks/content/donate.tsx"), "blocks/content/donate.tsx"),
  "acf/content-expandable": dynamic(
    () => import("../../../blocks/content/expandable.tsx"),
    "blocks/content/expandable.tsx",
  ),
  "acf/content-expandable-item": dynamic(
    () => import("../../../blocks/content/expandable-item.tsx"),
    "blocks/content/expandable-item.tsx",
  ),
  "acf/content-explore": dynamic(() => import("../../../blocks/content/explore.tsx"), "blocks/content/explore.tsx"),
  "acf/content-featured-columns": dynamic(
    () => import("../../../blocks/content/featured-columns.tsx"),
    "blocks/content/featured-columns.tsx",
  ),
  "acf/content-featured-columns-item": dynamic(
    () => import("../../../blocks/content/featured-columns-item.tsx"),
    "blocks/content/featured-columns-item.tsx",
  ),
  "acf/content-featured-film": dynamic(
    () => import("../../../blocks/content/featured-film.tsx"),
    "blocks/content/featured-film.tsx",
  ),
  "acf/content-featured-links": dynamic(
    () => import("../../../blocks/content/featured-links.tsx"),
    "blocks/content/featured-links.tsx",
  ),
  "acf/content-file-download": dynamic(
    () => import("../../../blocks/content/file-download.tsx"),
    "blocks/content/file-download.tsx",
  ),
  "acf/content-film-list": dynamic(
    () => import("../../../blocks/content/film-list.tsx"),
    "blocks/content/film-list.tsx",
  ),
  "acf/content-gallery": dynamic(() => import("../../../blocks/content/gallery.tsx"), "blocks/content/gallery.tsx"),
  "acf/content-image": dynamic(() => import("../../../blocks/content/image.tsx"), "blocks/content/image.tsx"),
  "acf/content-image-text-grid": dynamic(
    () => import("../../../blocks/content/image-text-grid.tsx"),
    "blocks/content/image-text-grid.tsx",
  ),
  "acf/content-image-text-grid-item": dynamic(
    () => import("../../../blocks/content/image-text-grid-item.tsx"),
    "blocks/content/image-text-grid-item.tsx",
  ),
  "acf/content-page-header": dynamic(
    () => import("../../../blocks/content/page-header.tsx"),
    "blocks/content/page-header.tsx",
  ),
  "acf/content-person": dynamic(() => import("../../../blocks/content/person.tsx"), "blocks/content/person.tsx"),
  "acf/content-price-table": dynamic(
    () => import("../../../blocks/content/price-table.tsx"),
    "blocks/content/price-table.tsx",
  ),
  "acf/content-price-table-row": dynamic(
    () => import("../../../blocks/content/price-table-row.tsx"),
    "blocks/content/price-table-row.tsx",
  ),
  "acf/content-spacer": dynamic(() => import("../../../blocks/content/spacer.tsx"), "blocks/content/spacer.tsx"),
  "acf/content-sponsors": dynamic(() => import("../../../blocks/content/sponsors.tsx"), "blocks/content/sponsors.tsx"),
  "acf/content-sponsors-item": dynamic(
    () => import("../../../blocks/content/sponsors-item.tsx"),
    "blocks/content/sponsors-item.tsx",
  ),
  "acf/content-text-image-tile": dynamic(
    () => import("../../../blocks/content/text-image-tile.tsx"),
    "blocks/content/text-image-tile.tsx",
  ),
  "acf/content-themed-columns": dynamic(
    () => import("../../../blocks/content/themed-columns.tsx"),
    "blocks/content/themed-columns.tsx",
  ),
  "acf/content-themed-columns-item": dynamic(
    () => import("../../../blocks/content/themed-columns-item.tsx"),
    "blocks/content/themed-columns-item.tsx",
  ),
  "acf/content-video": dynamic(() => import("../../../blocks/content/video.tsx"), "blocks/content/video.tsx"),
  "acf/film-film-contents": dynamic(
    () => import("../../../blocks/film/film-contents.tsx"),
    "blocks/film/film-contents.tsx",
  ),
  "acf/film-film-credits": dynamic(
    () => import("../../../blocks/film/film-credits.tsx"),
    "blocks/film/film-credits.tsx",
  ),
  "acf/film-film-guests": dynamic(() => import("../../../blocks/film/film-guests.tsx"), "blocks/film/film-guests.tsx"),
  "acf/film-film-header": dynamic(() => import("../../../blocks/film/film-header.tsx"), "blocks/film/film-header.tsx"),
  "acf/film-film-hierarchy": dynamic(
    () => import("../../../blocks/film/film-hierarchy.tsx"),
    "blocks/film/film-hierarchy.tsx",
  ),
  "acf/film-film-long-description": dynamic(
    () => import("../../../blocks/film/film-long-description.tsx"),
    "blocks/film/film-long-description.tsx",
  ),
  "acf/film-film-note": dynamic(() => import("../../../blocks/film/film-note.tsx"), "blocks/film/film-note.tsx"),
  "acf/film-film-related": dynamic(
    () => import("../../../blocks/film/film-related.tsx"),
    "blocks/film/film-related.tsx",
  ),
  "acf/film-film-short-description": dynamic(
    () => import("../../../blocks/film/film-short-description.tsx"),
    "blocks/film/film-short-description.tsx",
  ),
  "acf/film-film-sidebar": dynamic(
    () => import("../../../blocks/film/film-sidebar.tsx"),
    "blocks/film/film-sidebar.tsx",
  ),
  "acf/film-film-sponsors": dynamic(
    () => import("../../../blocks/film/film-sponsors.tsx"),
    "blocks/film/film-sponsors.tsx",
  ),
  "acf/film-film-tickets": dynamic(
    () => import("../../../blocks/film/film-tickets.tsx"),
    "blocks/film/film-tickets.tsx",
  ),
  "acf/footer-footer": dynamic(() => import("../../../blocks/footer/footer.tsx"), "blocks/footer/footer.tsx"),
  "acf/header-menu": dynamic(() => import("../../../blocks/header/menu.tsx"), "blocks/header/menu.tsx"),
  "acf/homepage-homepage-carousel": dynamic(
    () => import("../../../blocks/homepage/homepage-carousel.tsx"),
    "blocks/homepage/homepage-carousel.tsx",
  ),
  "acf/memberships-membership-grid": dynamic(
    () => import("../../../blocks/memberships/membership-grid.tsx"),
    "blocks/memberships/membership-grid.tsx",
  ),
  "acf/memberships-membership-grid-group": dynamic(
    () => import("../../../blocks/memberships/membership-grid-group.tsx"),
    "blocks/memberships/membership-grid-group.tsx",
  ),
  "acf/memberships-membership-grid-group-row": dynamic(
    () => import("../../../blocks/memberships/membership-grid-group-row.tsx"),
    "blocks/memberships/membership-grid-group-row.tsx",
  ),
  "acf/memberships-membership-levels": dynamic(
    () => import("../../../blocks/memberships/membership-levels.tsx"),
    "blocks/memberships/membership-levels.tsx",
  ),
  "acf/news-header-single": dynamic(
    () => import("../../../blocks/news/header-single.tsx"),
    "blocks/news/header-single.tsx",
  ),
  "acf/news-latest-news": dynamic(() => import("../../../blocks/news/latest-news.tsx"), "blocks/news/latest-news.tsx"),
  "acf/news-related-news": dynamic(
    () => import("../../../blocks/news/related-news.tsx"),
    "blocks/news/related-news.tsx",
  ),
  "acf/parts-part-site-footer": dynamic(
    () => import("../../../blocks/parts/part-site-footer.tsx"),
    "blocks/parts/part-site-footer.tsx",
  ),
  "acf/parts-part-site-header": dynamic(
    () => import("../../../blocks/parts/part-site-header.tsx"),
    "blocks/parts/part-site-header.tsx",
  ),
  "acf/search-search-page": dynamic(
    () => import("../../../blocks/search/search-page.tsx"),
    "blocks/search/search-page.tsx",
  ),
  "acf/templates-browse-films": dynamic(
    () => import("../../../blocks/templates/browse-films.tsx"),
    "blocks/templates/browse-films.tsx",
  ),
  "acf/venue-venue-header": dynamic(
    () => import("../../../blocks/venue/venue-header.tsx"),
    "blocks/venue/venue-header.tsx",
  ),
  "acf/venue-venue-list": dynamic(() => import("../../../blocks/venue/venue-list.tsx"), "blocks/venue/venue-list.tsx"),
  "acf/venue-venue-map": dynamic(() => import("../../../blocks/venue/venue-map.tsx"), "blocks/venue/venue-map.tsx"),
  ...core,
};

const info = {
  "acf/collections-collections-list": { "slug": "collections/collections-list", "flags": { "fullWidth": true } },
  "acf/content-button": { "slug": "content/button", "tags": ["richtext"], "flags": {} },
  "acf/content-category-carousel": {
    "slug": "content/category-carousel",
    "tags": ["subpage"],
    "flags": { "fullWidth": true },
  },
  "acf/content-chip": { "slug": "content/chip", "tags": ["richtext"], "flags": {} },
  "acf/content-ctas": { "slug": "content/ctas", "tags": ["subpage"], "flags": { "fullWidth": true } },
  "acf/content-ctas-item": { "slug": "content/ctas-item", "flags": {} },
  "acf/content-donate": { "slug": "content/donate", "tags": ["subpage"], "flags": { "fullWidth": true } },
  "acf/content-expandable": { "slug": "content/expandable", "tags": ["subpage"], "flags": {} },
  "acf/content-expandable-item": { "slug": "content/expandable-item", "flags": {} },
  "acf/content-explore": { "slug": "content/explore", "tags": ["subpage"], "flags": { "fullWidth": true } },
  "acf/content-featured-columns": {
    "slug": "content/featured-columns",
    "tags": ["subpage"],
    "flags": { "fullWidth": true },
  },
  "acf/content-featured-columns-item": { "slug": "content/featured-columns-item", "flags": {} },
  "acf/content-featured-film": { "slug": "content/featured-film", "tags": ["subpage"], "flags": { "fullWidth": true } },
  "acf/content-featured-links": {
    "slug": "content/featured-links",
    "tags": ["subpage"],
    "flags": { "fullWidth": true },
  },
  "acf/content-file-download": { "slug": "content/file-download", "tags": ["subpage"], "flags": { "fullWidth": true } },
  "acf/content-film-list": {
    "slug": "content/film-list",
    "tags": ["subpage", "homepage-root"],
    "flags": { "fullWidth": true },
  },
  "acf/content-gallery": { "slug": "content/gallery", "tags": ["subpage"], "flags": { "fullWidth": true } },
  "acf/content-image": { "slug": "content/image", "tags": ["subpage"], "flags": {} },
  "acf/content-image-text-grid": { "slug": "content/image-text-grid", "tags": ["subpage"], "flags": {} },
  "acf/content-image-text-grid-item": { "slug": "content/image-text-grid-item", "flags": {} },
  "acf/content-page-header": { "slug": "content/page-header", "tags": [], "flags": { "fullWidth": true } },
  "acf/content-person": { "slug": "content/person", "tags": ["subpage"], "flags": { "fullWidth": true } },
  "acf/content-price-table": { "slug": "content/price-table", "tags": ["subpage"], "flags": {} },
  "acf/content-price-table-row": { "slug": "content/price-table-row", "flags": {} },
  "acf/content-spacer": { "slug": "content/spacer", "tags": ["subpage"], "flags": {} },
  "acf/content-sponsors": { "slug": "content/sponsors", "tags": ["subpage"], "flags": {} },
  "acf/content-sponsors-item": { "slug": "content/sponsors-item", "flags": {} },
  "acf/content-text-image-tile": {
    "slug": "content/text-image-tile",
    "tags": ["subpage"],
    "flags": { "fullWidth": true },
  },
  "acf/content-themed-columns": {
    "slug": "content/themed-columns",
    "tags": ["subpage"],
    "flags": { "fullWidth": true },
  },
  "acf/content-themed-columns-item": { "slug": "content/themed-columns-item", "flags": {} },
  "acf/content-video": { "slug": "content/video", "tags": ["subpage"], "flags": {} },
  "acf/film-film-contents": { "slug": "film/film-contents", "tags": ["film-text"], "flags": {} },
  "acf/film-film-credits": { "slug": "film/film-credits", "tags": ["film-sidebar"], "flags": {} },
  "acf/film-film-guests": { "slug": "film/film-guests", "tags": ["film-text"], "flags": {} },
  "acf/film-film-header": { "slug": "film/film-header", "tags": ["film-root"], "flags": {} },
  "acf/film-film-hierarchy": { "slug": "film/film-hierarchy", "tags": ["film-text"], "flags": {} },
  "acf/film-film-long-description": { "slug": "film/film-long-description", "tags": ["film-text"], "flags": {} },
  "acf/film-film-note": { "slug": "film/film-note", "tags": ["film-text"], "flags": {} },
  "acf/film-film-related": { "slug": "film/film-related", "tags": ["film-root"], "flags": { "fullWidth": true } },
  "acf/film-film-short-description": { "slug": "film/film-short-description", "tags": ["film-text"], "flags": {} },
  "acf/film-film-sidebar": { "slug": "film/film-sidebar", "flags": {} },
  "acf/film-film-sponsors": { "slug": "film/film-sponsors", "tags": ["film-sidebar"], "flags": {} },
  "acf/film-film-tickets": { "slug": "film/film-tickets", "flags": {} },
  "acf/footer-footer": { "slug": "footer/footer", "tags": [], "flags": {} },
  "acf/header-menu": { "slug": "header/menu", "tags": [], "flags": {} },
  "acf/homepage-homepage-carousel": {
    "slug": "homepage/homepage-carousel",
    "tags": ["homepage-root"],
    "flags": { "fullWidth": true },
  },
  "acf/memberships-membership-grid": {
    "slug": "memberships/membership-grid",
    "tags": ["subpage"],
    "flags": { "fullWidth": true },
  },
  "acf/memberships-membership-grid-group": { "slug": "memberships/membership-grid-group", "flags": {} },
  "acf/memberships-membership-grid-group-row": { "slug": "memberships/membership-grid-group-row", "flags": {} },
  "acf/memberships-membership-levels": {
    "slug": "memberships/membership-levels",
    "tags": ["subpage"],
    "flags": { "fullWidth": true },
  },
  "acf/news-header-single": { "slug": "news/header-single", "tags": [], "flags": { "fullWidth": true } },
  "acf/news-latest-news": {
    "slug": "news/latest-news",
    "tags": ["subpage", "homepage-root"],
    "flags": { "fullWidth": true },
  },
  "acf/news-related-news": { "slug": "news/related-news", "tags": ["subpage"], "flags": { "fullWidth": true } },
  "acf/parts-part-site-footer": { "slug": "parts/part-site-footer", "flags": {} },
  "acf/parts-part-site-header": { "slug": "parts/part-site-header", "flags": {} },
  "acf/search-search-page": { "slug": "search/search-page", "flags": { "fullWidth": true } },
  "acf/templates-browse-films": { "slug": "templates/browse-films", "tags": [], "flags": {} },
  "acf/venue-venue-header": { "slug": "venue/venue-header", "tags": [], "flags": { "fullWidth": true } },
  "acf/venue-venue-list": { "slug": "venue/venue-list", "tags": ["subpage"], "flags": {} },
  "acf/venue-venue-map": { "slug": "venue/venue-map", "tags": ["venue"], "flags": {} },
};

blockManifestReader.set(manifest, info);

export default manifest;

if (import.meta.hot) {
  import.meta.hot.accept();
}
